import { NgModule } from "@angular/core";
import { SharedModule } from "app/shared/shared.module";
import { RouterModule } from "@angular/router";
import { ACCOUNT_ROUTES } from "app/account/account.routing";
import { UsersComponent } from 'app/account/components/users/users.component';
import { UserEditComponent } from 'app/account/components/user-edit/user-edit.component';
import { UserAddComponent } from 'app/account/components/user-add/user-add.component';
import { UnauthorizedComponent } from 'app/account/components/unauthorized/unauthorized.component';
import { UserCompanyListComponent } from "./components/user-company-list/user-company-list.component";
import { UserCompanyAddComponent } from "./components/user-company-add/user-company-add.component";

@NgModule({
    declarations: [
        UsersComponent,
        UserEditComponent,
        UserAddComponent,
        UnauthorizedComponent,
        UserCompanyListComponent,
        UserCompanyAddComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(ACCOUNT_ROUTES)
    ],
    providers: [

    ]
})
export class AccountModule { }
